import { render, staticRenderFns } from "./BusinessApplicationList.vue?vue&type=template&id=627d9152"
import script from "./BusinessApplicationList.vue?vue&type=script&lang=js"
export * from "./BusinessApplicationList.vue?vue&type=script&lang=js"
import style0 from "./BusinessApplicationList.vue?vue&type=style&index=0&id=627d9152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports